module.exports = __webpack_public_path__ + "static/DragonA-339d69eb3363248dfc26e0ce48a6a81f.gif";